import _has from "lodash/has";
import _map from "lodash/map";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { renderToString } from 'react-dom/server';
import u from 'unist-builder';
/**
 * This plugin doesn't actually transform Remark (MDAST) nodes to Rehype
 * (HAST) nodes, but rather, it prepares an MDAST shortcode node for HAST
 * conversion by replacing the shortcode text with stringified HTML for
 * previewing the shortcode output.
 */

export default function remarkToRehypeShortcodes({
  plugins,
  getAsset,
  resolveWidget
}) {
  return transform;

  function transform(root) {
    const transformedChildren = _map(root.children, processShortcodes);

    return _objectSpread(_objectSpread({}, root), {}, {
      children: transformedChildren
    });
  }
  /**
   * Mapping function to transform nodes that contain shortcodes.
   */


  function processShortcodes(node) {
    /**
     * If the node doesn't contain shortcode data, return the original node.
     */
    if (!_has(node, ['data', 'shortcode'])) return node;
    /**
     * Get shortcode data from the node, and retrieve the matching plugin by
     * key.
     */

    const {
      shortcode,
      shortcodeData
    } = node.data;
    const plugin = plugins.get(shortcode);
    /**
     * Run the shortcode plugin's `toPreview` method, which will return either
     * an HTML string or a React component. If a React component is returned,
     * render it to an HTML string.
     */

    const value = getPreview(plugin, shortcodeData);
    const valueHtml = typeof value === 'string' ? value : renderToString(value);
    /**
     * Return a new 'html' type node containing the shortcode preview markup.
     */

    const textNode = u('html', valueHtml);
    const children = [textNode];
    return _objectSpread(_objectSpread({}, node), {}, {
      children
    });
  }
  /**
   * Retrieve the shortcode preview component.
   */


  function getPreview(plugin, shortcodeData) {
    const {
      toPreview,
      widget,
      fields
    } = plugin;

    if (toPreview) {
      return toPreview(shortcodeData, getAsset, fields);
    }

    const preview = resolveWidget(widget);
    return /*#__PURE__*/React.createElement(preview.preview, {
      value: shortcodeData,
      field: plugin,
      getAsset
    });
  }
}